import React, { useEffect } from 'react'
import { DotLoader } from '@opallabs/lapidary'
import { assetProxyImageUrl } from '@opallabs/routing'
import { Modal } from '@opallabs/satellite'
import { MomentPreviewCard } from './MomentPreviewCard'
import { MomentPreviewHeader } from './MomentPreviewHeader'
import { styles } from './styles'
import { MomentPreviewModalProps } from './types'

export const MomentPreviewModal: React.FC<MomentPreviewModalProps> = ({
  closeDrawer,
  closeMomentPreview,
  getMomentData,
  modalVisible,
  momentId,
  momentPreviewData,
  navigateTo,
  stageName,
}) => {
  useEffect(() => {
    getMomentData(momentId)
  }, [getMomentData, momentId])

  const onCardClick = (): void => {
    navigateTo({ route: `moments/${momentPreviewData?.brandSlug}/${momentId}` })
    closeDrawer()
  }

  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  return (
    <Modal
      key={`moment-preview-card-${momentId}`}
      right={500}
      onClose={closeMomentPreview}
      visible={modalVisible}
      header={
        <div css={styles.header}>
          <MomentPreviewHeader
            dueDate={momentPreviewData?.storyDueDate?.toDateString()}
            stageName={stageName}
            storyName={momentPreviewData?.storyName}
          />
        </div>
      }
    >
      <div css={styles.card}>
        {momentPreviewData !== undefined ? (
          <React.Fragment>
            <div onClick={onCardClick}>
              <MomentPreviewCard
                {...momentPreviewData}
                coverImageUrl={
                  momentPreviewData.coverImageUuid
                    ? assetProxyImageUrl({
                        uuid: momentPreviewData.coverImageUuid,
                        height: 360,
                        width: 360,
                      })
                    : undefined
                }
              />
            </div>
            <div css={styles.button} onClick={onCardClick}>
              <div css={styles.linkDiv}>Review in Moment&apos;s Workflow</div>
            </div>
          </React.Fragment>
        ) : (
          <DotLoader />
        )}
      </div>
    </Modal>
  )
  /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
}
